import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import './Auth.css';

const ConfirmEmail = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading'); // 'loading', 'success', 'error'
  const [message, setMessage] = useState('');

  useEffect(() => {
    const confirmEmail = async () => {
      const userId = searchParams.get('userId');
      const token = searchParams.get('token');

      if (!userId || !token) {
        setStatus('error');
        setMessage('Invalid confirmation link. Please check your email for the correct link.');
        return;
      }

      try {
        const response = await fetch(`/api/auth/confirm-email?userId=${encodeURIComponent(userId)}&token=${encodeURIComponent(token)}`, {
          method: 'GET',
          headers: {
            'Accept': 'application/json'
          }
        });

        const data = await response.json();

        if (response.ok) {
          setStatus('success');
          setMessage(data.message || 'Email confirmed successfully! You can now log in.');
        } else {
          setStatus('error');
          setMessage(data.message || 'Error confirming email. The link may be expired or invalid.');
        }
      } catch (error) {
        setStatus('error');
        setMessage('Network error occurred. Please try again later.');
      }
    };

    confirmEmail();
  }, [searchParams]);

  if (status === 'loading') {
    return (
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-header">
            <h1>Confirming Your Email...</h1>
            <p>Please wait while we verify your email address</p>
          </div>
          
          <div className="loading-message" style={{textAlign: 'center', padding: '2rem'}}>
            <p>🔄 Confirming your email address...</p>
          </div>
        </div>
      </div>
    );
  }

  if (status === 'success') {
    return (
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-header">
            <h1>Email Confirmed! 🎉</h1>
            <p>Your account has been successfully verified</p>
          </div>
          
          <div className="success-message">
            <p>{message}</p>
            <p>You can now access all features of your PocketPE account.</p>
          </div>

          <div className="auth-footer">
            <Link to="/login" className="auth-button" style={{textDecoration: 'none', textAlign: 'center', display: 'block'}}>
              Sign In Now
            </Link>
            
            <p style={{marginTop: '1rem', textAlign: 'center'}}>
              <Link to="/" className="auth-link">
                Return to Home
              </Link>
            </p>
          </div>
        </div>
      </div>
    );
  }

  // Error state
  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-header">
          <h1>Email Confirmation Failed</h1>
          <p>We couldn't verify your email address</p>
        </div>
        
        <div className="error-message">
          <p>{message}</p>
        </div>

        <div className="auth-footer">
          <p>
            Need help?{' '}
            <Link to="/register" className="auth-link">
              Create a new account
            </Link>
            {' '}or{' '}
            <Link to="/login" className="auth-link">
              try signing in
            </Link>
          </p>
          
          <p style={{marginTop: '1rem', textAlign: 'center'}}>
            <Link to="/" className="auth-link">
              Return to Home
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ConfirmEmail;